import request from "@/utils/request";

/**
 * 门户网站首页
 * @param {*} data
 * @returns
 */
export function getWebHome(data) {
  return request({
    url: "/service-api/api/v1/public/web_home/",
    method: "get",
    params: data,
  });
}

/**
 * 咨讯列表
 * @param {{keyword?: string, page?: number, page_size?: number, category_code:string}} data 入参
 * @returns
 */
export function getContentInfo(data) {
  return request({
    url: "/service-api/api/v1/content/info/",
    method: "get",
    params: data,
  });
}

/**
 * 咨讯详情
 * @param {{id: string}} data 咨询id
 * @returns
 */
export function getContentInfoDetail(data) {
  return request({
    url: `/service-api/api/v1/content/info/${data.id}/`,
    method: "get",
  });
}

/**
 * 产业报告列表
 */
export function getReport(data) {
  return request({
    url: "/service-api/api/v1/content/report/",
    method: "get",
    params: data,
  });
}

/**
 * 产业报告详情
 */
export function getReportDetail(data) {
  return request({
    url: `/service-api/api/v1/content/report/${data.id}/`,
    method: "get",
  });
}

/**
 * 市场价格列表
 * @param {{is_market: number, herbal?: string, herbal_name?: string, specification?: string, market?: string, province?: string, page_size?: number}} data 入参
 * @param {number} data.is_market - 1， 查询市场价格； 0， 查询产地价格
 * @returns
 */
export function getTodayPrice(data) {
  return request({
    url: `/service-api/api/v1/data/today_price/`,
    method: "get",
    params: data,
  });
}

/**
 * 交易大厅的过滤条件
 * @param {{herbal: number}} data herbal：药材id
 * @returns
 */
export function getTradeCategory(data) {
  return request({
    url: `/service-api/api/v1/data/category/`,
    method: "get",
    params: data,
  });
}

// 门户交易大厅banner数据
export function getTransactionHome() {
  return request({
    url: `/service-api/api/v1/public/web_transaction_home/`,
    method: "get",
  });
}

// 供应列表
export function getSupply(data) {
  return request({
    url: `/service-api/api/v1/transaction/read_only_supply/`,
    method: "get",
    params: data,
  });
}

// 求购列表
export function getPurchase(data) {
  return request({
    url: `/service-api/api/v1/transaction/read_only_purchase/`,
    method: "get",
    params: data,
  });
}

// 招标列表
export function getBidding(data) {
  return request({
    url: `/service-api/api/v1/transaction/bidding/`,
    method: "get",
    params: data,
  });
}

// 招标详情
export function getBiddingDetail(data) {
  return request({
    url: `/service-api/api/v1/transaction/bidding/${data.id}/`,
    method: "get",
    // params: data,
  });
}

/**
 * 商户列表
 */
export function getMarchant(data) {
  return request({
    url: `/service-api/api/v1/transaction/marchant/`,
    method: "get",
    params: data,
  });
}

// 拍卖大厅列表
export function getAuction(data) {
  return request({
    url: `/service-api/api/v1/content/auchtion/`,
    method: "get",
    params: data,
  });
}

/**
 * 服务列表
 * @param {{is_shelf: number, category_code: string, page?: number, page_size?: number}} data 入参
 * @param {number} data.is_shelf - 是否上架 1 上架， 0 下架
 * @returns
 */
export function getService(data) {
  return request({
    url: `/service-api/api/v1/service/service/`,
    method: "get",
    params: data,
  });
}

/**
 * 服务详情
 * @param {{id: string}} data 服务id
 * @returns
 */
export function getServiceDetail(data) {
  return request({
    url: `/service-api/api/v1/service/service/${data.id}/`,
    method: "get",
  });
}

/**
 * 培训课程列表
 * @param {{ordering: string, page?: number, page_size?: number}} data 入参
 * @param {string} data.ordering - "publish_time"  按照发布时间正序排序；"-publish_time" 按照发布时间倒序排序；“rank" 权重正序显示； “-rank” 权重倒序显示
 * @returns
 */
export function getCourse(data) {
  return request({
    url: `/service-api/api/v1/expert/course/`,
    method: "get",
    params: data,
  });
}

/**
 * 培训课程详情
 * @param {{id: string}} data 课程id
 * @returns
 */
export function getCourseDetail(data) {
  return request({
    url: `/service-api/api/v1/expert/course/${data.id}/`,
    method: "get",
  });
}

/**
 * 专家列表
 * @param {{ordering: string, page?: number, page_size?: number}} data 入参
 * @param {string} data.ordering
 * @returns
 */
export function getExpert(data) {
  return request({
    url: `/service-api/api/v1/expert/expert/`,
    method: "get",
    params: data,
  });
}

/**
 * 专家详情
 * @param {{id: string}} data 专家id
 * @returns
 */
export function getExpertDetail(data) {
  return request({
    url: `/service-api/api/v1/expert/expert/${data.id}/`,
    method: "get",
  });
}

/**
 * 种植技术
 * @param {*} data
 * @returns
 */
export function getPlantStandard(data) {
  return request({
    url: `/service-api/api/v1/expert/plant_standard/`,
    method: "get",
    params: data,
  });
}

/**
 * 种植技术详情
 * @param {*} data
 * @returns
 */
export function getPlantStandardDetail(data) {
  return request({
    url: `/service-api/api/v1/expert/plant_standard/${data.id}/`,
    method: "get",
    params: data,
  });
}

/**
 * 项目政策/公示列表
 * @param {{category_code: string, ordering: string, page?: number, page_size?: number}} data 入参
 * @param {string} data.ordering
 * @returns
 */
export function getProject(data) {
  return request({
    url: `/service-api/api/v1/service/project/`,
    method: "get",
    params: data,
  });
}

/**
 * 项目政策/公示详情
 * @param {{id: string}} data 专家id
 * @returns
 */
export function getProjectDetail(data) {
  return request({
    url: `/service-api/api/v1/service/project/${data.id}/${
      data.code ? "?code=" + data.code : ""
    }`,
    method: "get",
  });
}

/**
 * 项目政策/公示详情
 * @param {object} data 专家id
 * @returns
 */
export function applyProject(data) {
  return request({
    url: `/service-api/api/v1/service/project_apply/`,
    method: "post",
    data,
  });
}

/**
 * 十大晋药列表
 */
export function getHerbalList() {
  return request({
    url: `/service-api/api/v1/data/herbal_info/`,
    method: "get",
  });
}

/**
 * 十大晋药
 */
export function getHerbalInfo(data) {
  return request({
    url: `/service-api/api/v1/data/herbal_info/${data.id}/`,
    method: "get",
  });
}

/**
 * 历史价格列表
 * @param {*} data
 * @returns
 */
export function getHistoricalPrice(data) {
  return request({
    url: `/service-api/api/v1/data/price_chart/`,
    method: "get",
    params: data,
  });
}

/**
 * 近几年价格表数据
 * @param {*} data
 * @returns
 */
export function getrecentYearsPrice(data) {
  return request({
    url: `/service-api/api/v1/data/price_table/`,
    method: "get",
    params: data,
  });
}

/**
 * 登录
 * @param {{username: string, password: string}} data
 * @returns
 */
export function login(data) {
  return request({
    url: `/service-api/api/v1/user/login/`,
    method: "post",
    data: data,
  });
}

/**
 * 退出
 */
export function logout() {
  return request({
    url: `/service-api/api/v1/user/logout/`,
    method: "post",
  });
}

/**
 * 获取图形验证码
 * 接口直接返回图片流，验证码唯一标识在响应头 X-Captcha-Uuid 中
 * @returns
 */
export function getCaptcha() {
  return request({
    url: `/service-api/api/v1/public/captcha/`,
    method: "get",
    responseType: "blob",
    // 返回原始响应，便于读取响应头 X-Captcha-Uuid
    rawResponse: true,
    params: { _t: new Date().getTime() },
  });
}

/**
 * 获取短信验证码
 * @param {{phone: string, timestamp: string, captcha_uuid?: string, captcha_code?: string}} data
 * @returns
 */
export function getPhoneCode(data) {
  return request({
    url: `/service-api/api/v1/user/get_phone_code/`,
    method: "post",
    data: data,
  });
}

/**
 * 注册账号
 * @param {{username: string, password: string}} data
 * @returns
 */
export function signUp(data) {
  return request({
    url: `/service-api/api/v1/user/register/`,
    method: "post",
    data: data,
  });
}

/**
 * 修改密码（未登陆修改密码）
 * @param {{username: string, password: string}} data
 * @returns
 */
export function changePassword(data) {
  return request({
    url: `/service-api/api/v1/user/change_password/notoken/`,
    method: "post",
    data: data,
  });
}

/**
 * 用户详情
 * @param {*} data
 * @returns
 */
export function getUser(data) {
  return request({
    url: `/service-api/api/v1/user/auth/${data.id}/`,
    method: "get",
  });
}

/**
 * 数据字典
 * @param {*} data
 * @returns
 */
export function getDataDict(data) {
  return request({
    url: `/service-api/api/v1/public/data_dict/`,
    method: "get",
    params: data,
  });
}

/**
 * 药材列表
 * @param {*} data
 * @returns
 */
export function getHerbal(data) {
  return request({
    url: `/service-api/api/v1/public/herbal/`,
    method: "get",
    params: data,
  });
}

// 市场列表
export function getMarket() {
  return request({
    url: "/service-api/api/v1/public/market/",
    method: "get",
    public: true,
  });
}

/**
 * 交易大厅-过滤条件
 * @param {*} data
 * @returns
 */
export function getDataCategory(data) {
  return request({
    url: `/service-api/api/v1/data/category/`,
    method: "get",
    params: data,
  });
}

/**
 * 创建收藏
 * type: 1， 收藏供应订单； 2， 收藏求购订单；
 * @param {*} data
 * @returns
 */
export function userCollect(data) {
  return request({
    url: `/service-api/api/v1/user/collect/`,
    method: "post",
    data: data,
  });
}

/**
 * 删除收藏
 * type: 1， 收藏供应订单； 2， 收藏求购订单；
 * @param {*} data
 * @returns
 */
export function userUncollect(data) {
  return request({
    url: `/service-api/api/v1/user/collect_deleted/`,
    method: "post",
    data: data,
  });
}

/**
 * 获取文件上传taskid
 */
export function getUploadTaskId() {
  return request({
    url: `/service-api/api/v1/public/upload_file/`,
    method: "get",
  });
}

/**
 * 文件分片上传
 */
export function uploadFragFile(data) {
  return request({
    url: `/service-api/api/v1/public/upload_file/`,
    method: "post",
    data: data,
  });
}
/**
 * 文件分片合并
 */
export function mergeFile(data) {
  return request({
    url: `/service-api/api/v1/public/upload_file/`,
    method: "put",
    data: data,
  });
}

/**
 * 关于我们（平台信息）
 */
export function getPlatform() {
  return request({
    url: `/service-api/api/v1/user/platform/`,
    method: "get",
    // noNeedToken 是否不需要token
    noNeedToken: true,
  });
}

/**
 * 检测服务-提交申请
 */
export function applyService(data) {
  return request({
    url: `/service-api/api/v1/service/service_apply/`,
    method: "post",
    data,
  });
}

/**
 * 特色区县
 */
export function getFeaturedDistricts(data) {
  return request({
    url: `/service-api/api/v1/data/characteristic_region/`,
    method: "get",
    params: data,
    // noNeedToken 是否不需要token
    noNeedToken: true,
  });
}

/**
 * 特色区县 详情
 */
export function getFeaturedDistrictsDeatail(data) {
  return request({
    url: `/service-api/api/v1/data/characteristic_region/${data.id}/`,
    method: "get",
    // noNeedToken 是否不需要token
    noNeedToken: true,
  });
}

/**
 * 菜单访问数据上报
 */
export function accessingDataReporting(data) {
  return request({
    url: `/service-api/api/v1/public/data_statistics/`,
    method: "post",
    // noNeedToken 是否不需要token
    noNeedToken: true,
    data,
  });
}

/**
 * 生产合作社列表
 */
export function getPlantEnterprise(data) {
  return request({
    url: "/service-api/api/v1/data/plant_enterprise/",
    method: "get",
    params: data,
  });
}

/**
 * 生产合作社详情
 */
export function getPlantEnterpriseDetails(data) {
  return request({
    url: `/service-api/api/v1/data/plant_enterprise/${data.id}/`,
    method: "get",
  });
}

/**
 * 成药企业列表
 */
export function getDrugEnterprise(data) {
  return request({
    url: "/service-api/api/v1/data/drug_enterprise/",
    method: "get",
    params: data,
  });
}
/**
 * 成药产品列表
 */
export function getDrugProduct(data) {
  return request({
    url: "/service-api/api/v1/data/drug/",
    method: "get",
    params: data,
  });
}
/**
 * 种植成本列表
 */
export function getPlantCost(data) {
  return request({
    url: "/service-api/api/v1/data/plant_cost/",
    method: "get",
    params: data,
  });
}

/**
 * 药材折干率列表
 */
export function getShrinkageRate(data) {
  return request({
    url: "/service-api/api/v1/data/shrinkage_rate/",
    method: "get",
    params: data,
  });
}

/**
 * 经典处方列表
 */
export function getPrescription(data) {
  return request({
    url: "/service-api/api/v1/data/prescription/",
    method: "get",
    params: data,
  });
}

/**
 * 产新期数据列表
 */
export function getHerbalProductivity(data) {
  return request({
    url: "/service-api/api/v1/data/herbal_productivity/",
    method: "get",
    params: data,
  });
}

/**
 * 遥感监测权限
 */
export function getAccessYGJC() {
  return request({
    url: "/service-api/api/v1/public/has_ygjc/",
    method: "get",
  });
}

/**
 * 药典标准
 */
export function getPharmacopoeia() {
  return request({
    url: `/service-api/api/v1/data/herbal_book/`,
    method: "get",
  });
}

/**
 * 药典标准详情
 */
export function getPharmacopoeiaDetails(data) {
  return request({
    url: `/service-api/api/v1/data/herbal_book/${data.id}/`,
    method: "get",
  });
}

/**
 * 全站搜索
 */
export function getSearch(data) {
  return request({
    url: `/service-api/api/v1/public/search/`,
    method: "get",
    params: data,
  });
}

/**
 * 全站搜索
 */
export function getRegion(data) {
  return request({
    url: `/service-api/api/v1/public/region/tree/`,
    method: "get",
    params: data,
  });
}

/**
 * 用于政策列表 归属组织查询条件
 */
export function getProjectDepartment(data) {
  return request({
    url: `/service-api/api/v1/service/project/query_department/`,
    method: "get",
    params: data,
  });
}

/**
 * 检查用户项目申报权限
 */
export function checkUserApplyProject(data) {
  return request({
    url: `/service-api/api/v1/service/project_apply/check_user/`,
    method: "post",
    data,
  });
}

/**
 * 公告列表
 * @param {{keyword?: string, page?: number, page_size?: number}} data 入参
 * @returns
 */
export function getNotice(data) {
  return request({
    url: "/service-api/api/v1/content/notice/",
    method: "get",
    params: data,
  });
}

/**
 * 公告详情
 * @param {{id: string}} data 咨询id
 * @returns
 */
export function getNoticeDetail(data) {
  return request({
    url: `/service-api/api/v1/content/notice/${data.id}/`,
    method: "get",
  });
}
